import { Component } from "react";
import { Link } from "react-router-dom";

class Header extends Component {
    constructor(props) {
        super(props);
        const savedState = localStorage.getItem("sidebarOpen") === "true";
        this.state = { isOpen: savedState };
    }

    toggleSidebar = () => {
        this.setState(
            (prev) => {
                const newState = !prev.isOpen;
                localStorage.setItem("sidebarOpen", newState);
                return { isOpen: newState };
            }
        );
    };

    closeSidebar = () => {
        this.setState({ isOpen: false }, () => {
            localStorage.setItem("sidebarOpen", "false");
        });
    };

    render() {
        // 在登入頁不顯示 Header
        const { location } = this.props;
        if (location.pathname === "/") {
            return null;
        }

        const { isOpen } = this.state;

        return (
            <div className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
                <div className="sidebar-header">
                    <span className="brand" onClick={this.toggleSidebar}>
                        ROS II PANEL
                    </span>
                </div>

                {isOpen && (
                    <nav className="sidebar-links">
                        <Link to="/panel" className="nav-item" onClick={this.closeSidebar}>Panel</Link>
                        {/* <Link to="/task" className="nav-item" onClick={this.closeSidebar}>Task</Link> */}
                    </nav>
                )}
            </div>
        );
    }
}

export default Header;
